import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_a2ff0632-ba58-4eba-8778-120ca1681ddb/artifacts/ft9gjhxd_franchise_india_knowledge_company_logo%20%281%29.jpeg";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/brands", label: "Brands" },
  { to: "/team", label: "Team" },
  { to: "/about", label: "About" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-navy/10 shadow-sm"
          : "bg-white/70 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
            <img
              src={LOGO}
              alt="Franchise India Knowledge Services"
              className="h-11 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `relative text-sm font-semibold tracking-wide transition-colors duration-200 ${
                    isActive ? "text-teal" : "text-navy hover:text-teal"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link
              to="/contact"
              data-testid="header-contact-cta"
              className="inline-flex items-center bg-navy text-white px-6 py-3 text-sm font-semibold tracking-wide hover:bg-navy-light transition-colors duration-300"
            >
              Get In Touch
            </Link>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-navy p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-navy/10">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 text-base font-semibold border-b border-navy/5 ${
                    isActive ? "text-teal" : "text-navy"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-contact-cta"
              className="mt-3 text-center bg-navy text-white px-6 py-3 text-sm font-semibold"
            >
              Get In Touch
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
